"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabeledSocialButton = void 0;
var react_1 = __importDefault(require("react"));
var theme_ui_1 = require("theme-ui");
var colors_1 = __importDefault(require("../../../theme/colors"));
var SocialButton_1 = require("../../atoms/SocialButton/SocialButton");
function LabeledSocialButton(_a) {
    var onClick = _a.onClick, label = _a.label, csx = _a.csx, sbProps = _a.sbProps, lsx = _a.lsx, children = _a.children, restProps = __rest(_a, ["onClick", "label", "csx", "sbProps", "lsx", "children"]);
    return (react_1.default.createElement(theme_ui_1.Flex, __assign({ onClick: onClick, sx: __assign({ width: "100%", alignItems: "center", backgroundColor: colors_1.default.jagexBlack, "&:hover": {
                filter: "brightness(1.1)",
                cursor: "pointer",
            }, "&:active": {
                boxShadow: "inset 0 0 5px " + colors_1.default.offBlack,
            } }, csx) }, restProps),
        react_1.default.createElement(SocialButton_1.SocialButton, __assign({ variant: "basicSocial" }, sbProps), children),
        react_1.default.createElement(theme_ui_1.Text, { variant: "text.small", sx: __assign({ px: 2 }, lsx) }, label)));
}
exports.LabeledSocialButton = LabeledSocialButton;
